import React from 'react';

const WarningComponent = props => (
  <svg width={16} height={16} {...props}>
    <defs>
      <circle id="prefix__a" cx={8} cy={8} r={8} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b" fill="#fff">
        <use xlinkHref="#prefix__a" />
      </mask>
      <use fill="#FFA42E" xlinkHref="#prefix__a" />
      <g mask="url(#prefix__b)">
        <path d="M0 0h16v16H0z" fill="#FF8D0A" />
        <path
          d="M7.374 4.964A.867.867 0 0 1 8.26 4h.146c.535 0 .932.432.887.964l-.385 4.545a.553.553 0 0 1-.55.491h-.05a.56.56 0 0 1-.55-.491l-.384-4.545zM8.334 12a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333z"
          fill="#FFF"
        />
      </g>
    </g>
  </svg>
);

export default WarningComponent;



// WEBPACK FOOTER //
// ./src/components/Form/FormHelper/iconComponent/warningCmp.js